import React from 'react';
import ProductCard from './ProductCard';
import '../../styles/product-grid.css';

const ProductGrid = ({ products, onProductSelect }) => {
  if (products.length === 0) {
    return (
      <div className="no-products">
        <span className="no-products-icon">📦</span>
        <h3>No Products Found</h3>
        <p>Try adjusting your search or add new products</p>
      </div>
    );
  }

  return (
    <div className="product-grid">
      {products.map(product => (
        <ProductCard
          key={product.id}
          product={product}
          onClick={() => onProductSelect(product)}
        />
      ))}
    </div>
  );
};

export default ProductGrid;